import { Bag } from '@models/bag.model';
import axios, { AxiosResponse } from 'axios';

const remove = async (bagId: number): Promise<Bag> => {
  const response = await axios.delete<Bag>(`/bags/${bagId}`);
  return response.data;
};

const buscaArquivoBag = async (bagId: number): Promise<AxiosResponse> => {
  const res = await axios.get(`/bags/${bagId}/arquivo`);
  return res;
};
export default {
  remove,
  buscaArquivoBag,
};
